<template>
  <div>
    <template v-if="!loading">
      <b-row align-v="center">
        <b-col lg="4">
          <b-row align-v="center">
            <b-col cols="8" lg="12">
              <h6 class="h6-semibold-azure-uppercase">{{ current.pad(2) }}</h6>
              <h3 class="h3-semibold-black">La cucina e il Condizionatore</h3>
            </b-col>

            <b-col cols="4" lg="12" v-if="isMobile" class="mb-4">
              <div class="icon">
                <img src="img/icone/SGR-Icons-Fornelli.svg">
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          <b-form-group
              label="La tua cucina è a gas metano?"
              label-for="field1"
              :state="states.cucina_gas"
          >
            <b-form-select id="field2" v-model="localOptions.cucina_condizionatore.cucina_gas" :options="siNo"
                           @input="setValid($event,'cucina_gas')"
                           class="form-control form-control-gray-900"></b-form-select>
          </b-form-group>

          <b-form-group
              label="Hai un impianto di condizionamento?"
              label-for="field2"
              :state="states.impianto_condizionamento"
          >
            <b-form-select id="field2" v-model="localOptions.cucina_condizionatore.impianto_condizionamento"
                           :options="siNo"
                           @input="setValid($event,'impianto_condizionamento')"
                           class="form-control form-control-gray-900"></b-form-select>
          </b-form-group>

        </b-col>
        <b-col lg="3" offset-lg="1" class=" text-center lg:text-right">
          <div class="icon" v-if="!isMobile">
            <img src="img/icone/SGR-Icons-Fornelli.svg">
          </div>
          <button @click="nextStep" class="button-azure-rounded mt-2 lg:mt-8 px-8">Avanti</button>
        </b-col>
      </b-row>
    </template>
  </div>

</template>

<script>
export default {
  name: 'Step-4',
  data() {
    return {
      thisStep: 4,
      localOptions: null,
      siNo: [{text: 'Seleziona un valore', value: ''}, {text: 'Sì', value: true}, {text: 'No', value: false}],
      loading: true,
      states: {},
    }
  },
  props: {
    steps: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    options: {
      type: [Array, Object],
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  created() {
    if (this.options.step < this.thisStep) this.$router.push({name: 'step-1'})
    this.$emit('setCurrent', this.thisStep)
    this.localOptions = {...this.options};
    this.loading = false;

    if(typeof this.$analytics != 'undefined') {
      this.trackFbViewContent('check-up-energetico', 'step-4');
    }
  },
  methods: {
    nextStep() {
      let that = this;
      let valid = true;
      that.states = {};
      for (const [key, value] of Object.entries(that.localOptions.cucina_condizionatore)) {
        if (value === null || value === '') {
          that.states[key] = true;
          valid = false;
        }
      }
      if (valid) this.$emit('nextStep', this.thisStep + 1, this.localOptions)
    },
    setValid(value, key) {
      this.states[key] = value === null || value === '';
    }
  },
}
</script>

<style scoped lang="scss">
</style>